// 100Totes add-ons: keep add-on cart lines in step with their bag line (配件加购第 3 段).
// Lines are linked by the hidden property _addon_group (set by totes-addons.js). After any cart change:
//   - add-on line whose bag line is gone        -> removed
//   - add-on quantity != bag quantity           -> set to the bag quantity (add-ons are per bag)
//   - Woven Label while bag quantity < LABEL_MIN -> removed (server MOQ would block checkout anyway)
// One /cart/update.js call for all fixes; never touches bag lines or lines without _addon_group.
(function (global, doc) {
  'use strict';
  if (global.TotesAddonsCart) return;
  var ADDON_HANDLES = {'bag-add-ons': 'addon', 'woven-label-add-on': 'label'};
  var LABEL_MIN = 100, NOTICE_KEY = 'totes-addons-cart-notice';
  var running = false, again = false, halted = false;
  var MSG_REJECTED = 'We could not update your add-on quantities automatically. Please check them in your cart, or contact us.';
  var MSG_UNCONFIRMED = 'We could not confirm whether your add-on quantities were updated. Please check them in your cart.';
  var MSG_REFRESH_FAILED = 'Your add-on quantities were updated, but the cart could not refresh. Please reload the page to see the latest cart.';

  // [R2 P2-2] A fix is applied only on a 2xx JSON cart response without an error status. Anything else
  // => show one message, never reload/re-render, and stop auto-sync for this page load (no refresh loop).
  function readCart(r) {
    return r.json().catch(function () { return null; }).then(function (body) {
      if (!r.ok || !body || typeof body !== 'object' || body.status || !Array.isArray(body.items)) {
        var err = new Error('cart update failed: HTTP ' + r.status + (body && body.description ? ' ' + body.description : ''));
        // 'rejected' only when the shop clearly refused: 4xx, or a non-5xx reply whose body carries an error
        // status. Any 5xx is 'unknown' FIRST (even with a JSON status) — a server error does not prove the
        // write did not happen. Unreadable replies are 'unknown' too. [R5 P3]
        err.cartUpdateFailed = r.status >= 500 ? 'unknown'
          : ((r.status >= 400 && r.status < 500) || (body && typeof body === 'object' && body.status)) ? 'rejected' : 'unknown';
        throw err;
      }
      return body;
    });
  }

  function root() { return (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/'; }

  // Pure: cart JSON -> {updates: {lineKey: qty}, notices: [text]}
  function plan(cart) {
    var groups = {}, updates = {}, notices = [];
    (cart && Array.isArray(cart.items) ? cart.items : []).forEach(function (item) {
      var g = item && item.properties && item.properties._addon_group;
      if (!g || typeof g !== 'string') return;
      var slot = groups[g] || (groups[g] = {bags: [], addons: []});
      if (ADDON_HANDLES[item.handle]) slot.addons.push(item); else slot.bags.push(item);
    });
    Object.keys(groups).forEach(function (g) {
      var slot = groups[g];
      if (slot.bags.length > 1) return;                  // ambiguous: leave untouched rather than guess
      var bag = slot.bags[0];
      slot.addons.forEach(function (a) {
        var target;
        if (!bag) target = 0;
        else if (ADDON_HANDLES[a.handle] === 'label' && bag.quantity < LABEL_MIN) {
          target = 0;
          notices.push('Woven Label needs at least ' + LABEL_MIN + ' pcs per bag line, so it was removed from "' + bag.product_title + '".');
        } else target = bag.quantity;
        if (a.quantity !== target) updates[a.key] = target;
      });
      if (!bag && slot.addons.length) notices.push('Add-ons were removed together with their bag.');
    });
    return {updates: updates, notices: notices};
  }

  function toast(text) {
    if (!text) return;
    var n = doc.createElement('div');
    n.setAttribute('role', 'status');
    n.textContent = text;
    n.style.cssText = 'position:fixed;left:50%;bottom:2rem;transform:translateX(-50%);z-index:1000;max-width:90vw;padding:1rem 1.4rem;border-radius:6px;background:#1a1a1a;color:#fff;font-size:1.3rem;line-height:1.4;box-shadow:0 4px 16px rgba(0,0,0,.25)';
    doc.body.appendChild(n);
    global.setTimeout(function () { n.remove(); }, 7000);
  }

  function onCartPage() { return !!doc.querySelector('cart-items'); }

  function reconcile() {
    if (halted) return Promise.resolve();
    if (running) { again = true; return Promise.resolve(); }
    running = true;
    // [R3 P2-2] read phase failures (cart.js) change nothing and stay retryable; once we start WRITING,
    // any failure — network reject, error response, unreadable body, re-render/reload throwing — is
    // reported once and stops auto-sync for this page load.
    // [R4 P3] the message must say only what we actually know:
    //   rejected by the shop -> not updated; no answer (network) -> unknown; confirmed but refresh failed -> updated.
    var writing = false, confirmed = false;
    return global.fetch(root() + 'cart.js', {headers: {Accept: 'application/json'}})
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return null;   // could not read the cart: change nothing
        var p = plan(cart);
        if (!Object.keys(p.updates).length) return null;
        var drawer = !onCartPage() && doc.querySelector('cart-drawer');
        var body = {updates: p.updates};
        if (drawer) body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        writing = true;
        return global.fetch(root() + 'cart/update.js', {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)
        }).then(readCart).then(function (state) {
          confirmed = true;
          var text = p.notices.join(' ');
          if (onCartPage()) {
            try { global.sessionStorage.setItem(NOTICE_KEY, text); } catch (e) { /* storage blocked: notice is optional */ }
            api._reload();
          } else {
            if (drawer && state.sections) drawer.renderContents(state);
            toast(text);
          }
        });
      })
      .catch(function (e) {
        if (global.console) global.console.error('[totes-addons-cart]', e);
        if (writing || (e && e.cartUpdateFailed)) {
          halted = true; again = false;
          toast(confirmed ? MSG_REFRESH_FAILED : (e && e.cartUpdateFailed === 'rejected') ? MSG_REJECTED : MSG_UNCONFIRMED);
        }
      })
      .then(function () {
        running = false;
        if (again) { again = false; return reconcile(); }
      });
  }

  function start() {
    try {
      var saved = global.sessionStorage.getItem(NOTICE_KEY);
      if (saved !== null) { global.sessionStorage.removeItem(NOTICE_KEY); toast(saved); }
    } catch (e) { /* storage blocked */ }
    // Dawn declares `const PUB_SUB_EVENTS` (constants.js) — a global binding, NOT a window property.
    var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : global.PUB_SUB_EVENTS;
    if (typeof global.subscribe === 'function' && events && events.cartUpdate) {
      global.subscribe(events.cartUpdate, function () { reconcile(); });
    }
    if (onCartPage()) reconcile();
  }

  var api = global.TotesAddonsCart = {plan: plan, reconcile: reconcile,
    _reload: function () { global.location.reload(); }};   // seam for tests (jsdom cannot stub location)
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
}(window, document));
